<template>
	<component v-model="row[prop]" :is="cpt.component?.()||'el-input'"
			   v-bind="view.props"></component>
</template>
<script>
import {computed} from 'vue'
import {getPropsEditor} from "@/components/scLowcode/propEditorContext";

export default {
	name: 'EditorColumn',
	props: {
		prop: {
			type: String,
			required: true,
		},
		row: {
			type: Object,
			required: true,
		},
		column: {
			type: Object,
			required: true,
		},
		view: {
			type: Object,
			default: () => ({})
		},
		format: {
			type: Object,
			default: () => ({format: (v) => v})
		}
	},
	setup(props) {
		const text = computed(() => props?.row?.[props.prop] || '')
		const cpt = getPropsEditor(props.view.editor)
		// console.log(cpt)
		return {
			text,
			cpt
		}
	}
}
</script>
<style lang="scss">

</style>
